module.exports = "/React/dist/1925965e29db94dbe1b6ba3b4c5fbbf8.jpg";